module.exports = __webpack_public_path__ + "static/hero-aviation-ind-210011c08344e0fc55adf1b45d7494c8.png";